import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'

type CrossSellHorizontalSliderItemCompactRedpointsMultiplierProps = {
  product?: CrossSellProduct
}

export const CrossSellHorizontalSliderItemCompactRedpointsMultiplier: FC<
  CrossSellHorizontalSliderItemCompactRedpointsMultiplierProps
> = ({ product }) => {
  const intl = useIntl()
  if (!product) {
    return null
  }

  const redpointMultiplier = Number.parseFloat(product.redpointfactor)

  if (!redpointMultiplier || redpointMultiplier <= 1) {
    return null
  }

  return (
    <div className="absolute -top-4 z-10 ml-2.5 overflow-hidden rounded border-l border-dark-error">
      <div className="relative -ml-2 mr-2 skew-x-[-20deg] rounded border border-dark-error bg-light-primary-low py-0.5 pl-4 pr-2">
        <div className="skew-x-[20deg] whitespace-nowrap text-[10.5px] text-dark-error">
          {`${redpointMultiplier}x ${intl.formatMessage({
            id: 'general.label.redPoints',
          })}`}
        </div>
      </div>
    </div>
  )
}
